module.exports = __webpack_public_path__ + "img/buynow-basic.adcc65a9.svg";